import { _breakP } from '../../js/lib/utils.js';
export default class swipeFigure {
  constructor() {
    this.figurePosition();
  }

  figurePosition() {
    const $swipeFigure = document.querySelectorAll('.js-figPosition');
    if ($swipeFigure.length) {
      $swipeFigure.forEach(elm => {
        let once = false;

        const scrollCallback = function () {
          function scrollInt() {
            const halfValue = 2;
            const elmImage = elm.querySelector('.photo__image');
            const elmW = elmImage.clientWidth - elm.clientWidth;
            const elmHW = elmW / halfValue;
            let initPos = 0;
            if (elm.classList.contains('js-figPosition-center')) {
              initPos = elmHW;
            }
            if (elm.classList.contains('js-figPosition-right')) {
              initPos = elmW;
            }

            if (once === false) {
              elm.scrollLeft = initPos;
              once = true;
            }
          }

          if (elm.getBoundingClientRect().top <= window.innerHeight) {
            if (elm.dataset.mode === 'sp') {
              _breakP.SP ? scrollInt() : null;
            } else if (elm.dataset.mode === 'pc') {
              !_breakP.SP ? scrollInt() : null;
            } else {
              scrollInt();
            }
          }
        };

        window.addEventListener('scroll', scrollCallback);
      });
    }
  }
}
